import {login} from '../../../apis/premier-plus-api';

export const authorizeUserCredentials = (growerId, emailAddress, growerIdOverride, emailAddressOverride, bypassEmailValidation) => (async (dispatch, getState) => {
  try {
    dispatch({
      type: 'USER_AUTHORIZATION_STARTED',
    });
    const authorization = await login(growerId, emailAddress, growerIdOverride, emailAddressOverride, bypassEmailValidation);
    dispatch({
      type: 'USER_AUTHORIZATION_SUCCEEDED',
      authorization: authorization,
      growerId: growerId,
      emailAddress: emailAddress,
      growerIdOverride: growerIdOverride,
      emailAddressOverride: emailAddressOverride,
    });
  } 
  catch (error) {
    dispatch({
      type: 'USER_AUTHORIZATION_FAILED',
    });
  }
});
